import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterTag } from '@apps/cmdb/models';
import { ColorsService } from '@common/services';

@Component({
    selector: 'aa-filter-tag-item',
    templateUrl: './filter-tag-item.component.html',
    styleUrls: [
        './filter-tag-item.component.scss'
    ],
    standalone: false
})
export class FilterTagItemComponent
{
    @Input() tag: FilterTag;
    @Output() public unselectTag: EventEmitter<FilterTag> = new EventEmitter();
    @Output() public toggleIncludedTag: EventEmitter<FilterTag> = new EventEmitter();
    @Output() public toggleEnabledTag: EventEmitter<FilterTag> = new EventEmitter();
    public isVerso: boolean = false;

    getCheckColor (color: string): string
    {
        return ColorsService.getContrastColor(color, '#ffffff', '#ff0000');
    }

    onEnter (): void
    {
        this.isVerso = true;
    }

    onLeave (): void
    {
        this.isVerso = false;
    }

    onUnselect (): void
    {
        this.unselectTag.emit(this.tag);
    }

    onToggleIncluded (): void
    {
        this.toggleIncludedTag.emit(this.tag);
    }

    onToggleEnabled (): void
    {
        this.toggleEnabledTag.emit(this.tag);
    }
}
